import { render, staticRenderFns } from "./ResultShareItem.vue?vue&type=template&id=76b64fa9&scoped=true&"
import script from "./ResultShareItem.vue?vue&type=script&lang=js&"
export * from "./ResultShareItem.vue?vue&type=script&lang=js&"
import style0 from "./ResultShareItem.vue?vue&type=style&index=0&id=76b64fa9&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b64fa9",
  null
  
)

export default component.exports